import { render, staticRenderFns } from "./vacationPortal.vue?vue&type=template&id=f2f24df4&scoped=true"
import script from "./vacationPortal.vue?vue&type=script&lang=js"
export * from "./vacationPortal.vue?vue&type=script&lang=js"
import style0 from "./vacationPortal.vue?vue&type=style&index=0&id=f2f24df4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f24df4",
  null
  
)

export default component.exports